import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/90 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/27c6b64e-ef87-419d-89de-15e7b8acfaf4.png"
              alt="全力以赴企業團建"
              className="h-14 w-auto object-contain"
            />
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors relative group whitespace-nowrap"
            >
              關於我們
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-500 transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors relative group whitespace-nowrap"
            >
              服務項目
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-500 transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button
              onClick={() => scrollToSection('workshop')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors relative group whitespace-nowrap"
            >
              工作坊
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-500 transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors relative group whitespace-nowrap"
            >
              聯絡我們
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-500 transition-all duration-300 group-hover:w-full"></span>
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="bg-black text-white px-6 py-2.5 rounded-full font-medium hover:bg-orange-500 transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            立即諮詢
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
